import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _Object$values from "@babel/runtime-corejs3/core-js-stable/object/values";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _startsWithInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/starts-with";
import React, { useContext, useState, useRef, useEffect } from 'react';
import classNames from 'classnames';
import ConfigContext from '../config-provider/ConfigContext';
import CityPanelItem from './city-panel-item';
import CityPanel from './city-panel';
import SearchPanel from './city-search-panel';
import usePopper from '../_utils/usePopper';

var CityPicker = function CityPicker(_ref) {
  var cityList = _ref.cityList,
      className = _ref.className,
      commons = _ref.commons,
      disabled = _ref.disabled,
      groups = _ref.groups,
      inputClassName = _ref.inputClassName,
      inputStyle = _ref.inputStyle,
      placeholder = _ref.placeholder,
      showTitle = _ref.showTitle,
      style = _ref.style,
      title = _ref.title;

  var _useContext = useContext(ConfigContext),
      getPrefixCls = _useContext.getPrefixCls,
      prefixCls = _useContext.prefixCls;

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      inputVal = _useState2[0],
      setInputVal = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      additionalVal = _useState4[0],
      setAdditionalVal = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      popperVisible = _useState6[0],
      setPopperVisible = _useState6[1];

  var inputRef = useRef(null);
  var allCity = useRef([]);
  useEffect(function () {
    var _context;

    if (!cityList) {
      return;
    }

    var domestic = cityList.domestic,
        foreign = cityList.foreign;
    allCity.current = _concatInstanceProperty(_context = []).call(_context, _toConsumableArray(_Object$values(domestic)), _toConsumableArray(_Object$values(foreign))).reduce(function (arr, current) {
      return _concatInstanceProperty(arr).call(arr, current);
    }, []);
  }, [cityList]);
  var cityPickerPrefixCls = getPrefixCls(prefixCls, 'city-picker');
  var containerCls = classNames("".concat(cityPickerPrefixCls, "-container"), className);
  var contentCls = classNames("".concat(cityPickerPrefixCls, "-content"));
  var titleCls = classNames("".concat(cityPickerPrefixCls, "-title"));
  var additionalInfoCls = classNames("".concat(cityPickerPrefixCls, "-info"));
  var inputCls = classNames("".concat(cityPickerPrefixCls, "-input"), inputClassName);
  var arrowCls = classNames('kdicon kdicon-arrow-down', "".concat(cityPickerPrefixCls, "-arrow"), {
    'arrow-up': popperVisible
  });

  var handleContainerClick = function handleContainerClick() {
    var _a;

    if (document.activeElement === inputRef.current) {
      return;
    }

    (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
  };

  var handleCitySelect = function handleCitySelect(city) {
    var _context2, _context3;

    setInputVal(city.name || '');
    var otherInfoStr = city.country === '中国' ? "".concat(city.province) : _concatInstanceProperty(_context2 = _concatInstanceProperty(_context3 = "".concat(city.province)).call(_context3, city.province ? ',' : '')).call(_context2, city.country);
    setAdditionalVal(otherInfoStr);
    setPopperVisible(false);
  };

  var handleFocus = function handleFocus() {
    if (popperVisible) {
      return;
    }

    setPopperVisible(true);
  };

  var handleChange = function handleChange(evt) {
    var value = evt.target.value;
    setAdditionalVal('');
    setInputVal(value);
  };

  var handlePopperVisibleChange = function handlePopperVisibleChange(visible) {
    if (!visible) {
      setPopperVisible(false);
    }
  };

  var inputSelector = /*#__PURE__*/React.createElement("div", {
    className: containerCls,
    style: style,
    onClick: handleContainerClick
  }, showTitle && /*#__PURE__*/React.createElement("div", {
    className: titleCls
  }, title), /*#__PURE__*/React.createElement("div", {
    className: contentCls
  }, /*#__PURE__*/React.createElement("input", {
    ref: inputRef,
    type: "text",
    readOnly: disabled,
    onChange: handleChange,
    placeholder: placeholder,
    style: inputStyle,
    className: inputCls,
    title: inputVal,
    value: inputVal,
    onFocus: handleFocus
  }), /*#__PURE__*/React.createElement("span", {
    className: additionalInfoCls
  }, additionalVal), /*#__PURE__*/React.createElement("i", {
    className: arrowCls
  })));
  var cityPanel = /*#__PURE__*/React.createElement(CityPanel, {
    commons: commons,
    groups: groups,
    cityList: cityList,
    onSelect: handleCitySelect
  });

  var getSearchResults = function getSearchResults() {
    var _context4;

    if (!allCity.current || allCity.current.length === 0 || !inputVal) {
      return [];
    }

    return _filterInstanceProperty(_context4 = allCity.current).call(_context4, function (city) {
      var _a;

      return (_a = city.name) === null || _a === void 0 ? void 0 : _startsWithInstanceProperty(_a).call(_a, inputVal);
    });
  };

  var searchPanel = /*#__PURE__*/React.createElement(SearchPanel, {
    keyword: inputVal,
    data: getSearchResults(),
    onSelect: handleCitySelect
  });
  var popperProps = {
    visible: popperVisible,
    placement: 'bottomLeft',
    trigger: 'focus',
    onVisibleChange: handlePopperVisibleChange
  };
  var panel = inputVal.length > 0 ? searchPanel : cityPanel;
  return usePopper(inputSelector, panel, popperProps);
};

CityPicker.displayName = 'CityPicker';
CityPicker.PanelItem = CityPanelItem;
CityPicker.Panel = CityPanel;
CityPicker.SearchPanel = SearchPanel;
export default CityPicker;